import {AiOutlineLoading} from "react-icons/ai";
import React from "react";

interface IconSuspenseProps {
    size?: string
}
function IconSuspense({size= "1.3em"}: IconSuspenseProps) {

    return (
        <AiOutlineLoading style={{
            animationName: "spinner-border",
            animationDuration: ".75s",
            animationTimingFunction: "linear",
            animationIterationCount: "infinite",
            color: "rgb(0, 123, 255)"
        }} size={size} />
    )
}

export default IconSuspense